import React, { Component } from "react";
import "./GeneralCss.css";

import GeneralZagl from "../img/GeneralZagl.jpg";
import fotoKota from "../img/foto kota.jpg";

export class General extends Component {
  handleLogoClick = () => {
    window.open("https://www.twitch.tv/shani58550", "_blank");
  };

  render() {
    const nowItems = (this.props.items || []).filter((el) => el.now === true);

    return (
      <section className="general">
        <div className="WathNow">

            <div className="WathNow">
                <div className="lettering">Смотрим сейчас</div>

                <div className="gCardsRow">
                    {[nowItems[0], nowItems[1]].map((el, index) =>
                        el ? (
                            <div className="gCard" key={el.id}>
                                <div className="gCard__media">
                                    <img alt={el.title || 'Смотрим сейчас'} src={el.img_url} />
                                </div>

                                <div className="gCard__bottom">
                                    <h2 className="gCard__title">{el.title}</h2>
                                    <p>Заказчик: {el.who}</p>
                                    <p>Заказано: {el.howMany}</p>
                                    <p>Дата заказа: {el.when}</p>
                                </div>
                            </div>
                        ) : (
                            <div className="gCard gCard--placeholder" key={`placeholder-${index}`}>
                                <div className="gCard__media">
                                    <img src={GeneralZagl} alt="Здесь пока пусто" />
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>

        {/* ПРАВО */}
        <button className="mainLogo" onClick={this.handleLogoClick} type="button">
          <img className="mainLogo__img" src={fotoKota} alt="Ссылка на стрим" />
          <div className="mainLogo__overlay" />
          <div className="mainLogo__text">Ссылка на стрим</div>
        </button>
      </section>
    );
  }
}

export default General;